module.exports = __webpack_public_path__ + "img/record_img_3.13885d60.png";